var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.name))])]),_c('p',[_vm._v("Due: "+_vm._s(_vm.deadlineDays)+" days before run date")]),_c('p',[_vm._v("First Due Date: "+_vm._s(_vm._f("date")(_vm.firstDueDate)))])])}
var staticRenderFns = []

export { render, staticRenderFns }